import { ExtendedMarginMultiplier, MarginMultiplier } from '../Margin'

import { capitalize } from './capitalaze'

const DEFAULT_MULTIPLIER = 8

// Import app breakpoint values from project variables. Using require to match CommonJS export.
// eslint-disable-next-line @typescript-eslint/no-var-requires
const theme = require('@/app/styles/default/variables.js')
const BREAKPOINTS: Record<string, string> = theme && theme.breakpoints ? theme.breakpoints : {}

/**
 * Generate plain CSS string rules for margins using CSS custom properties.
 * The returned string contains rules scoped to the provided className.
 * @param value - incoming prop value (e.g. '4x' or { xs: '2x', lg: '5x' })
 * @param direction - margin direction: 'top' | 'right' | 'bottom' | 'left'
 * @param className - CSS class to scope the generated rules to
 */
export const generateMarginCSS = (
	value: MarginMultiplier | ExtendedMarginMultiplier,
	direction: string,
	className: string
): string => {
	const varNameMap: Record<string, string> = {
		top: `mt`,
		right: `mr`,
		bottom: `mb`,
		left: `ml`
	}

	const varName = varNameMap[direction] || `m`

	if (typeof value === `string`) {
		const px = parseInt(value, 10) * DEFAULT_MULTIPLIER
		return `.${className} { --${varName}: ${px}px; }\n`
	}

	// value is an object with breakpoints
	return Object.entries(value)
		.map(([breakpoint, marginValue]) => {
			const bpKey = `screen${capitalize(breakpoint)}`
			const bp = (BREAKPOINTS as any)[bpKey]
			const px = parseFloat(marginValue as string) * DEFAULT_MULTIPLIER
			if (bp) {
				return `@media (min-width: ${bp}) { .${className} { --${varName}: ${px}px; } }\n`
			}
			// fallback: apply without media query
			return `.${className} { --${varName}: ${px}px; }\n`
		})
		.join(``)
}
